import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getNotesDetail = ({ bookIds, courseId }) =>
  httpClient.get(apis.GET_NOTES_DETAIL + courseId, {
    params: { bookIds },
  });

export const publicNotesRft = ({ token }) =>
  httpClient.get(apis.PUBLIC_NOTES_RFT, {
    params: { token },
  });

export const updateBulletNote = (payload) =>
  httpClient.post(apis.UPDATE_BULLET_NOTE, payload, { ignore: true });

export const addToFavoriteList = (payload) =>
  httpClient.post(apis.POST_VIDEOS_COLLECT, { ...payload }, { ignore: true });

export const updateQuestionNote = (payload) =>
  httpClient.post(apis.UPDATE_QUESTION_NOTE, payload, { ignore: true });

export const generateFile = ({ courseId, payload }) =>
  httpClient.get(`${apis.DOWNLOAD_NOTE_IN_DETAIL}${courseId}`, {
    params: payload,
  });
